/* 單獨列傳：甘寧傳（設計見 docs/CAMPAIGN-GANNING.md）
 * 這一條列傳自己的章節、地圖都在這個檔案登錄，不用改 campaign/index.ts。
 * 地圖 id 一律加前綴「ganning_」，免得和其他列傳撞名。 */
// @ts-nocheck
import ganning1 from '../story/ganning1.ts';
import ganning2 from '../story/ganning2.ts';
import ganning3 from '../story/ganning3.ts';
import ganning4 from '../story/ganning4.ts';
import ganning_xiakou from '../maps/ganning_xiakou.ts';
import ganning_yiling from '../maps/ganning_yiling.ts';
import ganning_wan from '../maps/ganning_wan.ts';
import ganning_yiyang from '../maps/ganning_yiyang.ts';

export default {
  list: { id: 'ganning', name: '甘寧傳', years: '203–215', parts: [
    { name: '江夏篇', chapters: ['ganning-1'] },
    { name: '歸吳篇', chapters: ['ganning-2', 'ganning-3', 'ganning-4'] },
  ] },
  chapters: [ganning1, ganning2, ganning3, ganning4],
  maps: { ganning_xiakou, ganning_yiling, ganning_wan, ganning_yiyang },
};
